import { render, staticRenderFns } from "./ProductGroupButton.vue?vue&type=template&id=b1aca940&scoped=true&"
import script from "./ProductGroupButton.vue?vue&type=script&lang=js&"
export * from "./ProductGroupButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupButton.vue?vue&type=style&index=0&id=b1aca940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aca940",
  null
  
)

export default component.exports